import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import DataTable from 'material-table';
import { Paper } from '@knockrentals/knock-shared-web';

import { getColumns } from './table-columns';
import { getTableOptions } from './table-options';
import { Pagination } from '../../../../common/Pagination';
import './_TemplateDataTable.scss';

const TemplateDataTable = ({
  getTableData,
  isFetching,
  rowsPerPage,
  rowsPerPageOptions,
  setPageIndex,
  setShouldLoadPageIndex,
  setTemplate,
  tableRef,
}) => {
  useEffect(() => {
    setShouldLoadPageIndex(true);
  }, []);

  const handleOnPageChange = (index) => {
    setPageIndex(index);
  };

  const tableColumns = getColumns({
    setTemplate,
  });

  return (
    <div className="templates-data-table">
      <DataTable
        columns={tableColumns}
        components={{
          Container: (props) => (
            <Paper {...props} elevation={4} className="data-table-paper" />
          ),
          Pagination: Pagination,
        }}
        data={getTableData}
        isLoading={isFetching}
        onChangePage={handleOnPageChange}
        options={getTableOptions(rowsPerPage, rowsPerPageOptions)}
        tableRef={tableRef}
      />
    </div>
  );
};

TemplateDataTable.propTypes = {
  getTableData: PropTypes.func,
  isFetching: PropTypes.bool,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  setPageIndex: PropTypes.func,
  setShouldLoadPageIndex: PropTypes.func,
  setTemplate: PropTypes.func,
  tableRef: PropTypes.shape({ current: PropTypes.object }),
};

export default TemplateDataTable;
